import { gql } from '@apollo/client';

export const loadValuesQuery = gql`
  query loadValues($id: String!) {
    SalesforceManagement {
      entities {
        businessPartner(id: $id) {
          views {
            SalesforceManagement_all {
              properties {
                RelatedCompany {
                  Id
                }
              }
            }
          }
        }
      }
    }
    Accounting_PaymentMethodList: __type(name: "Accounting_PaymentMethodList") {
      name
      enumValues {
        name
      }
    }
    Accounting_BillTypeList: __type(name: "Accounting_BillTypeList") {
      name
      enumValues {
        name
      }
    }
    Core {
      queries {
        getSystemCurrencies {
          core_SystemCurrency_Id
          core_SystemCurrency_BasicCurrency {
            Id
            Code
            Title
            Symbol
          }
          core_SystemCurrency_SecondaryCurrency {
            Id
            Code
            Title
            Symbol
          }
        }
      }
    }
  }
`;

export const getAccountsByCompanyAndCurrencyQuery = gql`
  query getAccountsByCompanyAndCurrency(
    $selectedCompanyID: String
    $accountCurrency: String
    $pageNumber: Int!
    $pageSize: Int!
  ) {
    Accounting {
      queries {
        GetAccountsByCompanyandCurrency(
          SelectedCompany: $selectedCompanyID
          AccountCurrency: $accountCurrency
          pagination: { pageNumber: $pageNumber, pageSize: $pageSize }
        ) {
          paging {
            totalCount
            pageSize
            pageNumber
          }
          items {
            accounting_ChartOfAccounts_AccountID
            accounting_ChartOfAccounts_AccountName
            accounting_ChartOfAccounts_Id
          }
        }
      }
    }
  }
`;

export const getPaymentDetailsQuery = gql`
  query getPaymentAndTransactionDetails($PaymentID: String!) {
    Accounting {
      queries {
        GetPayment(PaymentID: $PaymentID) {
          accounting_Payments_Id
          accounting_Payments_PaymentDate
          accounting_Payments_PaymentCurrency
          accounting_Payments_PaymentMethod
          accounting_Payments_ReferenceNo
          accounting_Payments_TotalAmountReceived
          linkedAmendment_AmendmentNumber
          linkedAmendment_AmendmentLineNumber
          parentBill_ParentBillCategory
          policyDetails_PolicyNumber
          policyDetails_CertificateNumber
          policyDetails_Type
          billDetails_BillNumber
          billDetails_Id
          billDetails_Currency {
            Code
            Symbol
          }
          billDetails_DueDate
          billDetails_AmountDue
          paymentDetails_AmountDue
          paymentDetails_AmountOutstanding
          paymentDetails_AmountOutstandingCurrency
          paymentDetails_AmountReceived
          accounting_Payments_PaymentDocuments {
            contentType
            fileName
            id
            length
            location
            path
          }
          accounting_Payments_Note
        }
        GetPaymentTransactionDetails(PaymentID: $PaymentID) {
          transactionDetails_RelatedAccount {
            views {
              Accounting_all {
                properties {
                  AccountID
                  AccountName
                  AccountCurrency {
                    Id
                    Code
                    Symbol
                  }
                }
              }
            }
          }
          transactionDetails_Id
          transactionDetails_Description
          transactionDetails_AccountDebit
          transactionDetails_AccountCredit
          transactionDetails_SystemDebit
          transactionDetails_SystemCredit
          transactionDetails_SystemSecondaryDebit
          transactionDetails_SystemSecondaryCredit
          transaction_TotalSystemDebit
          transaction_TotalSystemCredit
        }
      }
    }
  }
`;

export const modifyPaymentMutation = `
  mutation modifyPayment(
    $currentPaymentID: String!
    $note: String
    $UploadedDocuments: [Upload]
    $PersistDocuments: [String]
  ) {
    accounting {
      actions {
        modifyPayment(
          CurrentPaymentID: $currentPaymentID
          Note: $note
          UploadedDocuments: $UploadedDocuments
          PersistDocuments: $PersistDocuments
        )
      }
    }
  }
`;

export const getNotesList = gql`
  query getNotesList(
    $CurrentBillingAccountID: String!
    $Type: Accounting_NoteTypeList
  ) {
    Accounting {
      queries {
        NotesList(
          CurrentBillingAccountID: $CurrentBillingAccountID
          Type: $Type
        ) {
          accounting_Notes_Id
          accounting_Notes_Type
          accounting_Notes_Reference
          accounting_Notes_Amount
          accounting_Notes_AmountOutstanding
          accounting_Notes_Status
          accounting_Notes_ModifiedByText
          accounting_Notes_LinkedAmendmentID {
            id
          }
          billDetails_Currency {
            Symbol
          }
          linkedAmendment_PolicyID {
            views {
              Production_all {
                properties {
                  PolicyNumber
                }
              }
            }
          }
        }
      }
    }
  }
`;
